document.addEventListener('turbolinks:load', () => {
  $('#package_feature_ids').select2();
  $('#package_scenario_ids').select2();
});
